import React from "react";

interface SliderProps {
  initialValue: number
  min: number
  max: number
  step: number
  onChange: (value: number) => void
}

const Slider = (props: SliderProps) => {
  const { initialValue, min, max, step, onChange } = props;
  const [value, setValue] = React.useState(initialValue);

  const onSlide = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number(e.target.value);
    setValue(value);
    onChange(value);
  };

  const percentage = ((value - min) / (max - min)) * 100;

  return <div className="slider-wrapper">
    {!navigator.userAgent.includes("Gecko/") && <div style={{ width: `${percentage}%` }} className="slider-filled" />}
    <input
      className="slider-input"
      type="range"
      min={min}
      max={max}
      step={step}
      value={value}
      onChange={onSlide}
    />
  </div>;
};

export default Slider;